<template>
    <div class="legal-databases-wrapper">
        <table class="legal-databases-table">
            <thead>
            <tr>
                <th v-for="(item,index) in columnList"
                    :style="{width:item.width+'px'}" :key="index">
                    {{item.title}}
                    <template v-if="item.statistics">
                        {{$t('symbol.bracket.before')}}{{item.statisticsCount}}{{$t('symbol.bracket.after')}}
                    </template>
                </th>
            </tr>
            </thead>
            <tbody v-for="(item, index) in tableData" :key="index">
            <tr :class="{'row--stripe': index%2===1}">
                <td>{{index + 1}}</td>
                <td>
                    <Country :country="item.country"/>
                </td>
                <td>
                    <Status :count="item.legal_status_filtering"/>
                </td>
                <td>
                    <Status :count="item.expiration_date"/>
                </td>
                <td>
                    <Status :count="item.review_documents"/>
                </td>
                <td>
                    <Status :count="item.transfer_information"/>
                </td>
                <td>
                    <Status :count="item.licensing_information"/>
                </td>
                <td>
                    <Status :count="item.pledge_information"/>
                </td>
                <td>
                    <Status :count="item.litigation_information"/>
                </td>
                <td>
                    <Status :count="item.reexamine_information"/>
                </td>
                <td>
                    <Status :count="item.invalid_information"/>
                </td>
                <td>
                    <Status :count="item.customs_record_information"/>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { getLegalDataSourceApi } from 'library-@//apis/core_basic_api/data_coverage';
import { get } from 'lodash';
import Status from '../../../components/Status/Status';
import Country from '../../../components/Country/Country';
import { getStatusTabCount } from '../../../util';

export default {
    name: 'LegalDatabases',
    components: {
        Status,
        Country
    },
    data() {
        return {
            columnList: [
                { field: 'id', title: '#', width: 50 },
                { field: 'country', title: this.$t('dataCoverage.authority') },
                {
                    field: 'legal_status_filtering',
                    title: this.$t('dataCoverage.globalPatentDatabases.legalStatus'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'expiration_date',
                    title: this.$t('dataCoverage.legalDatabases.estimatedExpiration'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'review_documents',
                    title: this.$t('page.status.review_documents'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'transfer_information',
                    title: this.$t('dataCoverage.legalDatabases.transfer'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'licensing_information',
                    title: this.$t('dataCoverage.legalDatabases.licensing'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'pledge_information',
                    title: this.$t('dataCoverage.legalDatabases.pledge'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'litigation_information',
                    title: this.$t('dataCoverage.legalDatabases.litigation'),
                    width: 100,
                    statistics: true
                },
                {
                    field: 'reexamine_information',
                    title: this.$t('dataCoverage.legalDatabases.reexamination'),
                    width: 120,
                    statistics: true
                },
                {
                    field: 'invalid_information',
                    title: this.$t('dataCoverage.legalDatabases.invalidation'),
                    width: 90,
                    statistics: true
                },
                {
                    field: 'customs_record_information',
                    title: this.$t('dataCoverage.legalDatabases.customs'),
                    width: 90,
                    statistics: true
                },
            ],
            tableData: []
        };
    },
    methods: {
        getStatusTabCount,
        initLegalData() {
            getLegalDataSourceApi().then(res => {
                this.tableData = get(res, 'table_list', []).map((item, index) => {
                    item = { ...item, ...item.status };
                    delete item.status;
                    return item;
                });
                this.columnList.forEach(item=>{
                    if (item.statistics) {
                        item.statisticsCount = getStatusTabCount(this.tableData, item.field);
                    }
                });
            });
        },
    },
    created() {
        this.initLegalData();
    }
};
</script>

<style lang="scss">
.legal-databases-wrapper {
    width: 1280px;
    margin: 0 auto;
    padding: 0 36px 36px;
    box-sizing: border-box;

    .legal-databases-table {
        thead {
            position: sticky;
            top: 106px;
            z-index: 20;
        }

        tbody {
            td {
                line-height: 22px;
            }
        }
    }
}
</style>
